import { useQuery } from '@tanstack/react-query';

import { agent } from 'api/agent';
import useLanguage from 'hooks/useLanguage';
import { BriefProps } from 'utils/types';

export const fileKey = ['file'];

const useFileBrief = () => {
  const { blueLang } = useLanguage();

  return useQuery({
    queryKey: [fileKey, 'brief'],
    enabled: !!blueLang,
    queryFn: () => agent
      .getClient()('file-data/calc?dataType=brief', blueLang ? { params: { blueLang } } : undefined)
      .then((response) => {
        const result: BriefProps[] = [];
        response?.data?.data?.forEach((element: any) => {
          result.push({
            ['Indutry Code']: element?.['0'],
            ['Industry']: element?.['1'],
            ['Application Code']: element?.['4'],
            ['Sub-Industry']: element?.['3'],
            ['Product recommendation order']: element?.['6'],
            ['Application']: element?.['5'],
            ['Sub-industry Code']: element?.['2'],
            ['Product recommendation']: element?.['7'],
            ['Project Brief Code']: element?.['8'],
            ['Product description']: element?.['9'],
            ['Product benefits1']: element?.['11'],
            ['Product benefits2']: element?.['12'],
            ['Product benefits3']: element?.['13'],
            ['Product benefits4']: element?.['14'],
            ['Product benefits5']: element?.['15'],
            ['Product benefits6']: element?.['16'],
            ['Additional optional benefits']: element?.['17'],
            ['Additional optional benefits2']: element?.['18'],
            ['Additional optional benefits3']: element?.['19'],
            ['Additional optional benefits4']: element?.['20'],
            ['Additional optional benefits5']: element?.['21'],
            ['Additional optional benefits6']: element?.['22'],
          });
        });

        return result as BriefProps[];
      }),
  });
};

export default useFileBrief;
